import { NewVersionModal } from '@/view/shared/versionCheck';
import { useReleaseWatcherViewModel } from '@/viewmodel/shared/versionCheck';
import type { ReactNode } from 'react';

export function ReleaseWatcher(): ReactNode {
  return <NewVersionModal {...useReleaseWatcherViewModel()} />;
}
